import Head from "next/head";
import {
  PENGKINIAN_DATA_PATH,
  UPDATE_DATA_WIDGET,
  UPLOAD_KUITANSI_PATH,
  DIRECT_DEBIT_PATH,
  DIRECT_DEBIT_WIDGET,
  WIDGET_STYLE,
} from "src/constants";

const Page = {
  PENGKINIAN_DATA_PELANGGAN: [PENGKINIAN_DATA_PATH, UPDATE_DATA_WIDGET],
  UPLOAD_KUITANSI: [UPLOAD_KUITANSI_PATH, UPDATE_DATA_WIDGET],
  DIRECT_DEBIT: [DIRECT_DEBIT_PATH, DIRECT_DEBIT_WIDGET],
};

type WidgetProps = { asPath?: string; slug?: string };

const Widget = (props: WidgetProps) => {
  const { asPath, slug = "" } = props;

  let widgetType;
  for (const key in Page) {
    const pathPattern = new RegExp(`^${Page[key][0]}(/.*)?$`);

    if (pathPattern.test(asPath)) {
      widgetType = key;
    }
  }

  const path = Page[widgetType]?.[0] + (slug ? `/${slug}` : "");
  const src = Page[widgetType]?.[1];

  console.log({ path, src });

  return (
    <Head>
      <link
        id="genesys-cx-widget-styles"
        type="text/css"
        rel="stylesheet"
        href={WIDGET_STYLE}
      />
      <script async id="genesys-cx-widget-script" src={src} />
      <script>
        {`
        var path = window.location.pathname;
                          var page = path==="${path}"
                if(!window._genesys)window._genesys = {};
                        if(!window._gt)window._gt = [];

                window._genesys.widgets = {
                      main: {
                            debug: page,
                            theme: "light",
                            lang: "en",
                            customStylesheetID: "genesys_widgets_custom",
                            plugins: [
                                  "cx-webchat",
                                  "cx-webchat-service"
                            ]
                      },
                      webchat: {
                            dataURL: "https://livechat.homecredit.co.id/genesys/2/chat/customer-support",
                            apikey: "",
                            userData: {},
                            autoInvite: {
                                  enabled: false,
                                  timeToInviteSeconds: 5,
                                  inviteTimeoutSeconds: 30
                            },
                            chatButton: {
                                  enabled: page,
                                  openDelay: 1000,
                                  effectDuration: 300,
                                  hideDuringInvite: true
                            },
                            uploadsEnabled: true
                      }
                };

                        (function(o){
                  var f = function(){
                    var d = o.location;
                    o.aTags = o.aTags || [];

                    for(var i=0;i<o.aTags.length;i++){
                      var oTag = o.aTags[i];
                      var fs = d.getElementsByTagName(oTag.type)[0], e;
                      if(d.getElementById(oTag.id)) return; e = d.createElement(oTag.type); e.id = oTag.id;
                      if(oTag.type == "script"){e.src = oTag.path;}
                                        else{e.type = 'text/css';e.rel = 'stylesheet';e.href = oTag.path;}
                      if(fs){fs.parentNode.insertBefore(e, fs);}else{d.head.appendChild(e);}
                    }},ol = window.onload;
                    if(o.onload){typeof window.onload != "function"?window.onload=f:window.onload=function(){ol();f();}}else f();
                })({location: document,
                    onload: false,
                    aTags: [{type:"script", id:"genesys-cx-widget-script", path:"https://web-dev.homecredit.co.id${path}"},
                    {type:"link", id:"genesys-cx-widget-styles", path:"https://web-dev.homecredit.co.id/livechathcid/widgets.min_beauty.css"}]});
        `}
      </script>
    </Head>
  );
};

export default Widget;
